import React from "react";
import Header from "./Header";
import ApplicantList from "../applicants/ApplicantList";

export default function LayoutApplicants() {
  return (
    <>
      <Header />
      <ApplicantList />
    </>
  );
}
